import { apiDelete, apiPost } from './http'

export const findAll = async request => apiPost('/documents/findall', request, { auth: true })

export const getPath = async request => apiPost('/documents/getpath', request, { auth: true })

export const upload = async request => apiPost('/documents/upload', request, { auth: true })

export const categories = async request =>
  apiPost('/documents/categories/findall', request, { auth: true })

export const createCategory = async request =>
  apiPost('/documents/categories/create', request, { auth: true })

export const removeCategory = async id =>
  apiDelete(`/documents/categories/delete/${id}`, { auth: true })
